import { Reveal } from "./shared";

export default function RootCause() {
  return (
    <section id="rootcause" className="relative py-32 md:py-48 bg-[#0f1724] overflow-hidden border-t border-white/5">
      {/* ambient glow */}
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[700px] h-[700px] bg-[#b88457] opacity-[0.06] blur-[140px] rounded-full pointer-events-none" />
      <div className="absolute inset-0 tech-grid opacity-20 pointer-events-none" />

      <div className="relative mx-auto max-w-[1100px] px-6 md:px-10 text-center">
        <Reveal>
          <div className="font-mono-data text-[#b88457] text-xs tracking-[0.35em] mb-10 flex items-center justify-center gap-4">
            <span className="w-10 h-px bg-[#b88457]" />
            06 // ROOT CAUSE ESTABLISHED
            <span className="w-10 h-px bg-[#b88457]" />
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <h2 className="font-display font-medium text-white text-5xl md:text-7xl tracking-tight mb-6">
            The determination
          </h2>
          <div className="w-16 h-px bg-[#b88457] mx-auto mb-16" />
        </Reveal>

        <Reveal delay={0.2}>
          <p className="font-display font-medium text-white text-2xl md:text-4xl leading-[1.25] tracking-tight max-w-4xl mx-auto">
            A <span className="text-[#b88457]">−43 °C calibration drift</span> on thermocouple T-99
            caused the controller to over-fire heater H-401, driving V-402 beyond design temperature
            and pressure. The <span className="text-[#b88457]">relief path was bypassed</span> by valve
            V-402A, left 40% open after the March turnaround — preventing PSV-402 from venting the
            overpressure.
          </p>
        </Reveal>

        <Reveal delay={0.3}>
          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 border border-white/10 max-w-3xl mx-auto text-left">
            {[
              ["CONTRIBUTING", "Calibration procedure gap — no field verification of T-99 vs TW-99B"],
              ["CONTRIBUTING", "Car-seal management — V-402A not restored on turnaround punch list"],
              ["SYSTEMIC", "MOC-2231 closed without relief-path line-up confirmation"],
            ].map(([k, v], i) => (
              <div key={i} className="bg-[#152430] p-6">
                <div className="font-mono-data text-[10px] tracking-[0.2em] text-[#b88457] mb-3">{k}</div>
                <p className="text-zinc-400 text-sm leading-relaxed">{v}</p>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.4}>
          <div className="mt-16 flex flex-col sm:flex-row items-center justify-center gap-5">
            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                if (window.__lenis) window.__lenis.scrollTo(0);
                else window.scrollTo({ top: 0, behavior: "smooth" });
              }}
              data-testid="replay-cta"
              className="font-mono-data text-[11px] tracking-[0.2em] text-black bg-[#b88457] px-8 py-4 hover:bg-white transition-colors duration-300"
            >
              ↺ REPLAY INVESTIGATION
            </a>
            <span className="font-mono-data text-[11px] tracking-[0.2em] text-zinc-500">
              REPORT ID: ASR-ALPHA7-RCA-FINAL
            </span>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
